import styled from 'styled-components';

import { MAX_APP_CONTAINER_WIDTH_NEW } from '@makemydeal/dr-shared-ui-utils';

export const ActivityRouteContainer = styled.div`
    max-width: ${MAX_APP_CONTAINER_WIDTH_NEW};
    margin: 0 auto;
    width: 100%;
    padding: 0 0.5rem;
`;
